import React, { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { docApi, docErr } from "@/lib/docApi";
import { btnGold, btnRed, field } from "@/components/nds/windows/finance/parts";

const INPUT = { textarea: "textarea", number: "number", date: "date", email: "email", phone: "tel", money: "number" };

/** Pick an active template, fill its variable fields, and let the AI write the draft. */
export default function GenerateForm({ templates, onCreated, onCancel }) {
  const active = templates.filter((t) => t.status === "active");
  const [tid, setTid] = useState(active[0]?.id || "");
  const [title, setTitle] = useState("");
  const [values, setValues] = useState({});
  const [busy, setBusy] = useState(false);
  const tpl = active.find((t) => t.id === tid);
  const missing = tpl?.variable_fields.some((f) => f.required && !values[f.field_name]);
  const go = async () => {
    setBusy(true);
    try { const d = await docApi.post("/documents", { template_id: tid, title, variable_values: values }); toast.success("AI draft ready"); onCreated(d); }
    catch (e) { toast.error(docErr(e)); } finally { setBusy(false); }
  };
  if (!active.length) return <div data-testid="doc-gen-no-templates" className="p-5 text-sm text-nex-muted">No active templates. Create one in the Template Library first. <button type="button" onClick={onCancel} className={btnRed}>Back</button></div>;
  return (
    <div data-testid="doc-gen-form" className="p-5 space-y-3">
      <select data-testid="doc-gen-template" className={`${field} w-full`} value={tid} onChange={(e) => { setTid(e.target.value); setValues({}); }}>
        {active.map((t) => <option key={t.id} value={t.id}>{t.template_name} · {t.document_type}</option>)}
      </select>
      <input data-testid="doc-gen-title" className={`${field} w-full`} placeholder="Document title" value={title} onChange={(e) => setTitle(e.target.value)} />
      {tpl?.variable_fields.map((f) => (
        <label key={f.field_name} className="block text-xs text-nex-muted">{f.label}{f.required ? " *" : ""}
          {INPUT[f.field_type] === "textarea"
            ? <textarea data-testid={`doc-gen-field-${f.field_name}`} rows={3} className={`${field} w-full mt-1`} value={values[f.field_name] || ""} onChange={(e) => setValues({ ...values, [f.field_name]: e.target.value })} />
            : <input data-testid={`doc-gen-field-${f.field_name}`} type={INPUT[f.field_type] || "text"} className={`${field} w-full mt-1`} value={values[f.field_name] || ""} onChange={(e) => setValues({ ...values, [f.field_name]: e.target.value })} />}
        </label>
      ))}
      <div className="flex gap-2 pt-2">
        <button type="button" disabled={busy || !title.trim() || missing} onClick={go} data-testid="doc-gen-submit" className={`${btnGold} inline-flex items-center gap-1.5`}>
          {busy ? <><Loader2 className="h-3 w-3 animate-spin" /> Generating with AI…</> : <><Sparkles className="h-3 w-3" /> Generate draft</>}
        </button>
        <button type="button" onClick={onCancel} data-testid="doc-gen-cancel" className={btnRed}>Cancel</button>
      </div>
    </div>
  );
}
